import React from "react";


export function CardContato({ contato }) {


  function handleDragStart(e){

    e.dataTransfer.setData(
      "contatoId",
      contato.id
    );

  }


  return (

    <div

      draggable

      onDragStart={handleDragStart}

      className="
        bg-white
        border
        border-border
        rounded-card
        p-4
        shadow-sm
        cursor-grab
        hover:shadow-md
        transition
      "

    >


      <h4
        className="
          font-bold
          text-text-primary
        "
      >
        {contato.nome}
      </h4>



      {contato.empresa && (

        <p
          className="
            text-small
            text-text-secondary
            mt-1
          "
        >
          {contato.empresa}
        </p>

      )}



      {contato.telefone && (

        <p
          className="
            text-caption
            text-text-secondary
            mt-2
          "
        >
          {contato.telefone}
        </p>

      )}



      <span

        className="
          inline-block
          mt-3
          text-caption
          bg-accent/20
          text-primary
          px-2
          py-1
          rounded-full
        "

      >
        {contato.origem || "Manual"}

      </span>


    </div>

  );

}